import React, { Component } from "react";
import "../assets/topo.module.css";
import { isAuthenticated, IS_ADMIN, IS_EMPRESA } from "../services/auth";
import "../assets/menu_porta.css";
import { Dropdown } from "semantic-ui-react";
import { verify_mobile, abrevia_nome } from "../utils/Utils";
import Topo_Mobile from "./Topo_Mobile";
import { getUserNode } from "../services/auth_node";

export default class Topo extends Component {
  state = {
    open_menu: true,
    width: "-1%",
    display: "none",
    logo:
      "https://files.voitto.com.br/ftp-files/assets/images/voitto-white-full.png?size=200",
    busca: false,
    indexEmpresa: 0,
    widthBusca: "45%",
    notGestor: 0,
    load: false,
  };
  changeColor() {}

  navOpen() {
    if (this.state.open_menu) {
      this.setState({ display: "block" }, () => {
        setTimeout(() => {
          for (var i = 0; i < 20; i++) {
            this.setState({
              width: i + "%",
            });
          }
        }, 50);
      });
      this.setState({ open_menu: false });
    } else {
      for (var i = 20; i > 0; i--) {
        this.setState({
          width: i + "%",
        });
      }
      setTimeout(() => {
        this.setState({ open_menu: true, display: "none" });
      }, 300);
    }
  }

  async componentDidMount() {
    const user = getUserNode();
    if (!user.empresa) {
      window.location.href = "/";
    }

    this.setState({
      id: user.id,
      nome: user.nome,
      foto:
        user.foto ||
        "https://files.voitto.com.br/ftp-files/user_files/perfil/121def829d6211f18dae1b32fc7f7a34.jpeg",
      is_empresa: user.gestorEmpresa,
      is_premium: user,
      load: true,
      aluno_empresa: user.aluno_empresa || user.alunoEmpresa,
      logo: user.empresa.logo,
      urlempresa: user.gestorEmpresa
        ? "/painelempresa/" + user.empresa.url
        : "/universidade/" + user.empresa.url,
      indexEmpresa: user.empresa.id,
    });

    let titulo = "Universidade Digital " + user.empresa.nome;
    let subtitulo = undefined;

    if (user.gestorEmpresa && this.props.aluno == undefined) {
      titulo = "Dashboard de Gestão: Universidade Digital " + user.empresa.nome;
      subtitulo = user.empresa.nome;
    }
    this.setState({ titulo, subtitulo });
  }

  Open_URL = (URL) => {
    window.location.href = URL;
  };

  DropdownExampleDropdown = () => (
    <Dropdown
      style={{ zIndex: 99999999999 }}
      id="hs"
      text={abrevia_nome(this.state.nome)}
      style={{ cursor: "pointer" }}
    >
      <Dropdown.Menu>
        <Dropdown.Item
          style={{ display: "flex" }}
          onClick={() => this.Open_URL("/online/editar-perfil")}
          icon="edit icon"
          text="Editar Perfil"
        />
        {getUserNode().alunoEmpresa ? (
          <Dropdown.Item
            style={{ display: "flex" }}
            onClick={() => this.Open_URL("/online/certificados/")}
            icon="student icon"
            text="Certificados"
          />
        ) : null}
        {getUserNode().alunoEmpresa ? (
          <Dropdown.Item
            style={{ display: "flex" }}
            onClick={() =>
              this.Open_URL("/universidade/" + getUserNode().empresa.url)
            }
            icon="book icon"
            text="Cursos"
          />
        ) : null}
        {IS_ADMIN() ? (
          <Dropdown.Item
            style={{ display: "flex" }}
            onClick={() => this.Open_URL("/admin/")}
            text="Painel Administrativo"
          />
        ) : null}
        {IS_EMPRESA() ? (
          <Dropdown.Item
            style={{ display: "flex" }}
            onClick={() =>
              this.Open_URL("/painelempresa/" + getUserNode().empresa.url)
            }
            text={"Painel de Gestão"}
          />
        ) : null}
        {IS_EMPRESA() ? (
          <Dropdown.Item
            style={{ display: "flex" }}
            onClick={() =>
              this.Open_URL("/relatoriogeral/" + getUserNode().empresa.url)
            }
            text={"Controle de Alunos "}
          />
        ) : null}

        <Dropdown.Item
          style={{ display: "flex" }}
          onClick={() => this.Open_URL("/sair")}
          icon="sign out alternate icon"
          text="Sair"
        />
      </Dropdown.Menu>
    </Dropdown>
  );

  bar_foto() {
    if (this.state.load)
      return (
        <div
          style={{ marginLeft: "10%", cursor: "initial" }}
          className="ui dropdown item"
          tabindex="0"
          id="dropper"
        >
          <img
            className="ui avatar circular image user-profile-foto"
            alt="Perfil"
            src={this.state.foto}
          />
          {this.DropdownExampleDropdown()}
        </div>
      );
    else return <div></div>;
  }

  clickBusca(e) {
    if (e.id == "buscaButton") {
      this.setState({ busca: true, widthBusca: "100%" });
    } else if (e.id != "menu_input" && e.id != "submit-pesquisa") {
      this.setState({ busca: false, widthBusca: "45%" });
    }
  }

  render() {
    if (verify_mobile()) {
      return (
        <Topo_Mobile load={this.state.load} empresa={this.state.is_empresa} />
      );
    }
    if (!isAuthenticated())
      return (
        <div
          style={{ height: 50, backgroundColor: "#030303", zIndex: 1000 }}
          className="ui inverted black top fixed menu transition grid computer only toposss"
        >
          <div
            style={{
              width: "95%",
              marginLeft: "2.5%",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <a
              target="_blank"
              href="/"
              style={{
                height: "50px",
                padding: "10px",
                position: "relative",
                right: "2%",
              }}
              className="item"
            >
              {this.state.is_premium == "1" ? (
                <img
                  className="ui item  premium"
                  src="https://files.voitto.com.br/ftp-files/assets/images/logo_premium.png"
                  style={{
                    border: "none",
                    width: 90,
                    marginTop: 10,
                    marginRight: -18,
                    objectFit: "contain",
                  }}
                  alt="Voitto"
                />
              ) : (
                <img
                  className="ui item logo  droppedsda"
                  style={{
                    border: "none",
                    width: 90,
                    marginTop: 10,
                    marginRight: 18,
                    objectFit: "contain",
                  }}
                  src="https://files.voitto.com.br/ftp-files/assets/images/voitto-white-full.png?size=200"
                  alt="Voitto"
                />
              )}
            </a>
            <div id="div_input2">
              <form action="/busca" style={{ width: "103%" }}>
                <input
                  id="menu_input"
                  name="filter"
                  style={{ width: "100%", padding: 20 }}
                  className="portalSearchAntigo noti-searchAntigo load_aovivo load_voittocasts load_artigos load_materiais"
                  style={{}}
                  type="text"
                  placeholder="O que você quer aprender hoje?"
                ></input>
                <button
                  style={{ backgroundColor: "transparent", border: "none" }}
                  type="submit"
                >
                  <i
                    id="submit-pesquisa"
                    className="inverted circular search link icon submit-pesquisa"
                  ></i>
                </button>
              </form>
            </div>
            <a
              style={{ marginLeft: "3%" }}
              id="dropper"
              href="/login"
              className="item"
            >
              <button
                className="ui inverted button sing-in-btn"
                style={{ borderRadius: 0, fontWeight: "900" }}
              >
                <b>Entrar</b>
              </button>
            </a>
            <div
              onClick={this.navOpen.bind(this)}
              id="mySidenavToRight "
              style={{
                width: this.state.width,
                display: this.state.display,
                zIndex: 999999999999999,
              }}
              className="sidenavToRight"
            >
              <div
                style={{ display: "flex" }}
                className="content-menu-left"
                style={{ marginTop: -20, marginBottom: -15 }}
              >
                <i
                  style={{ zIndex: 9999, color: "white" }}
                  className="ui white icon close"
                ></i>
                <a href="/">
                  <img
                    className="ui item logo droppedsda"
                    style={{
                      border: "none",
                      width: 90,
                      marginTop: "10px !important",
                      marginRight: -18,
                      objectFit: "contain",
                    }}
                    src="https://files.voitto.com.br/ftp-files/assets/images/voitto-white-full.png?size=200"
                    alt="Voitto"
                  />
                </a>
              </div>
              <a
                style={{ display: "flex", flexDirection: "row" }}
                href="/certificacao/certificacao-green-e-black-belt-em-lean-seis-sigma"
              >
                <p style={{ color: "white", fontSize: "13px" }}>
                  <i className="ui icon certificate"></i>Certificações
                </p>
              </a>
              <a style={{ display: "flex" }} href="/cursos">
                <p style={{ color: "white", fontSize: "13px" }}>
                  <i className="ui icon play"></i> Treinamentos
                </p>
              </a>
              <a style={{ display: "flex" }} href="/ao-vivo">
                <p style={{ color: "white", fontSize: "13px" }}>
                  <i className="ui icon red circle"></i> Transmissões Ao Vivo
                </p>
              </a>
              <a style={{ display: "flex" }} href="/empresas">
                <p style={{ color: "white", fontSize: "13px" }}>
                  <i className="ui icon handshake"></i> Atendimento à Empresas
                </p>
              </a>
              <a style={{ display: "flex" }} href="/historias-de-sucesso">
                <p style={{ color: "white", fontSize: "13px" }}>
                  <i className="ui icon star"></i> Histórias de Sucesso
                </p>
              </a>
              <a style={{ display: "flex" }} href="/blog">
                <p style={{ color: "white", fontSize: "13px" }}>
                  <i className="ui icon globe"></i> Blog
                </p>
              </a>
              <a style={{ display: "flex" }} href="/blog/eu-colunista">
                <p style={{ color: "white", fontSize: "13px" }}>
                  <i className="ui icon graduation cap"></i> Seja um Colunista
                </p>
              </a>
              <a style={{ display: "flex" }} href="/faq">
                <p style={{ color: "white", fontSize: "13px" }}>
                  <i className="ui icon comments outline"></i> Central de Ajuda
                </p>
              </a>
            </div>
          </div>
        </div>
      );
    else
      return (
        <div
          onClick={(event) => this.clickBusca(event.target)}
          style={{ height: 50, backgroundColor: "#030303", zIndex: 1000 }}
          className="ui inverted black top fixed menu transition grid computer only toposss"
        >
          <div
            style={{
              width: "95%",
              marginLeft: "2.5%",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <a href={this.state.urlempresa}>
              <img
                className=""
                style={{
                  border: "none",
                  marginLeft: "1.1%",
                  width: "135px",
                  objectFit: "contain",
                  maxHeight: "40px",
                  padding: 2,
                }}
                src={
                  this.state.logo == "" && this.props.logo != undefined
                    ? this.props.logo
                    : this.state.logo
                }
                alt="Voitto"
              />
            </a>
            {!this.state.busca ? (
              <div
                className="text"
                style={{
                  textTransform: "capitalize",
                  width: "100%",
                  color: "rgba(255, 255, 255, 0.9)",
                  fontWeight: "500",
                  textAlign: "center",
                  fontSize: "16px",
                  fontFamily: "'Montserrat', sans-serif",
                }}
              >
                <p style={{ marginBottom: 0 }}>{this.state.titulo}</p>
              </div>
            ) : null}

            {this.bar_foto()}
            <div
              onClick={this.navOpen.bind(this)}
              id="mySidenavToRight"
              style={{ width: this.state.width, display: this.state.display }}
              className="sidenavToRight"
            >
              <div
                style={{ display: "flex" }}
                className="content-menu-left"
                style={{ marginTop: -20, marginBottom: -15 }}
              >
                <i
                  style={{ zIndex: 9999, color: "white" }}
                  className="ui white icon close"
                ></i>
                <a href="/">
                  <img
                    className="ui item logo"
                    style={{
                      border: "none",
                      width: 90,
                      marginTop: 10,
                      marginRight: -18,
                      objectFit: "contain",
                    }}
                    src={this.props.logo}
                    alt="Voitto"
                  />
                </a>
              </div>
              <a
                style={{ display: "flex", flexDirection: "row" }}
                href="/certificacao/certificacao-green-e-black-belt-em-lean-seis-sigma"
              >
                <p style={{ color: "white", fontSize: "13px" }}>
                  <i className="ui icon certificate"></i>Certificações
                </p>
              </a>
              <a style={{ display: "flex" }} href="/cursos">
                <p style={{ color: "white", fontSize: "13px" }}>
                  <i className="ui icon play"></i> Treinamentos
                </p>
              </a>
              <a style={{ display: "flex" }} href="/ao-vivo">
                <p style={{ color: "white", fontSize: "13px" }}>
                  <i className="ui icon red circle"></i> Transmissões Ao Vivo
                </p>
              </a>
              <a style={{ display: "flex" }} href="/empresas">
                <p style={{ color: "white", fontSize: "13px" }}>
                  <i className="ui icon handshake"></i> Atendimento à Empresas
                </p>
              </a>
              <a style={{ display: "flex" }} href="/historias-de-sucesso">
                <p style={{ color: "white", fontSize: "13px" }}>
                  <i className="ui icon star"></i> Histórias de Sucesso
                </p>
              </a>
              <a style={{ display: "flex" }} href="/blog">
                <p style={{ color: "white", fontSize: "13px" }}>
                  <i className="ui icon globe"></i> Blog
                </p>
              </a>
              <a style={{ display: "flex" }} href="/blog/eu-colunista">
                <p style={{ color: "white", fontSize: "13px" }}>
                  <i className="ui icon graduation cap"></i> Seja um Colunista
                </p>
              </a>
              <a style={{ display: "flex" }} href="/faq">
                <p style={{ color: "white", fontSize: "13px" }}>
                  <i className="ui icon comments outline"></i> Central de Ajuda
                </p>
              </a>
            </div>
          </div>

          <style>
            {`
                        #notificacoes-badge {
                            background-color: #ff5f5f;
                            color: #fff;
                            position: absolute;
                            top: 10px;
                            right: 10px;
                            padding: 4px;
                            font-size: 10px;
                            font-weight: 900;
                            text-align: center;
                            border-radius: 2px!important;
                            width: 18px;
                            height: 18px;
                        }
                        .menu .voitto-coin-icon{
                            width: 28px;
                            height: 28px;
                            background-position: center center;
                            background-size: contain;
                            background-repeat: no-repeat;
                            background-image: url(https://files.voitto.com.br/ftp-files/assets/images/voittocoinsicon.png);
                            /* width: 50px; */
                            /* height: 50px; */
                            display: inline-table;
                            position: relative;
                            border: none;
                            outline: none;
                            background-color: transparent
                        }
                        .ui.menu .item:before{
                            width:0px!Important;
                        }
                    `}
          </style>
        </div>
      );
  }
}
